export default __webpack_public_path__ + "5aa7f6a1447648e55ac6d0ac70fc9dd8.png";